"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const CircleNotifications_1 = __importDefault(require("@mui/icons-material/CircleNotifications"));
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const services_1 = require("../../../common/services");
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const MessageList_1 = __importDefault(require("../Notifications/MessageList"));
const NotificationDetailPage = styled_components_1.default.div `
  position: relative;
  background: #fff;
  display: flex;
  width: 100%;
  height: calc(100vh - 100px);

  @media (min-width: 1000px) {
    width: 50%;
  }
`;
const NotificationDetail = ({ currentLocale, userData, history, fetchNotifications, baseUrl, setSelectedNotification, selectedNotification, }) => {
    const [messages, setMessages] = (0, react_1.useState)([]);
    const [openDialog, setOpenDialog] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const fetchNotificationDetail = () => {
        if (!selectedNotification) {
            return;
        }
        const { section, type, id } = selectedNotification.reference;
        if (id) {
            setIsLoading(true);
            services_1.apiService
                .getNotificationDetail({
                locale: currentLocale,
                token: userData.token,
                notificationType: type,
                id,
                section,
            })
                .then((data) => {
                setIsLoading(false);
                setMessages(data.notifications);
                if (!selectedNotification.read) {
                    const event = new CustomEvent("fetchNotificationBadge");
                    window.dispatchEvent(event);
                    const channel = new BroadcastChannel("notifications");
                    channel.postMessage({});
                }
            })
                .catch(() => {
                setIsLoading(false);
                setSelectedNotification(null);
                setOpenDialog(true);
            });
        }
    };
    (0, react_1.useEffect)(() => {
        fetchNotificationDetail();
    }, [selectedNotification]);
    const handleClose = (event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setOpenDialog(false);
        }
    };
    return (react_1.default.createElement(NotificationDetailPage, null,
        isLoading && selectedNotification ? (react_1.default.createElement(Loader_1.default, null)) : (react_1.default.createElement(MessageList_1.default, { selectedNotification: selectedNotification, messages: messages })),
        react_1.default.createElement(material_1.Dialog, { open: openDialog, onClose: handleClose },
            react_1.default.createElement(material_1.DialogContent, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "15px",
                } },
                react_1.default.createElement(CircleNotifications_1.default, { sx: {
                        width: "40px",
                        height: "40px",
                    } }),
                react_1.default.createElement(material_1.DialogContentText, null, i18n_js_1.default.t("message_center_notification_not_available_hint"))),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        fetchNotifications(false);
                        const event = new CustomEvent("fetchNotificationBadge");
                        window.dispatchEvent(event);
                        history.push(`${baseUrl}${baseUrl !== "/" ? "/" : ""}notifications`);
                        handleClose();
                    } }, i18n_js_1.default.t("message_center_notification_not_available_button"))))));
};
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(NotificationDetail));
